import React, { useEffect, useState } from 'react';
import { useHistory, Redirect } from "react-router-dom";
import Loader from '../../Components/Loader/Loader';
import { VerifySubscription } from "../../Apis/VerifySubscription";
import { handleApiError } from '../../actions/notificationActions';
import Toaster from '../../Components/Toaster/Toaster';
import { useDispatch, useSelector } from 'react-redux';
import TagManager from 'react-gtm-module';
import { updateUserSubscriptionData } from "../../actions/userSubscriptionActions";
import { GetStripeSubscriptions } from "../../Apis/GetStripeSubscriptions";

function SubscriptionVerification() {

    const history = useHistory();
    const dispatch = useDispatch();
    const Subscribed = () => history.push("/ClientPortfolios");
    const [isLoading, setIsLoading] = useState(false);
    const [subscriptionStatus, setSubscritionStatus] = useState('');
    const subscriptionsDetails = useSelector(state => state.userSubscription.subscriptionData) || {};
    const { user_type: userType, customer_id: CustomerID } = subscriptionsDetails;
    
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const fetchSubscriptions = () => {
        return new Promise((resolve, reject) => {
            GetStripeSubscriptions().then((subscriptionsResponse) => {
                if (subscriptionsResponse.status === 200) {
                    dispatch(updateUserSubscriptionData(subscriptionsResponse.result.stripe_plan_details));
                    resolve();
                } else {
                    handleApiError(subscriptionsResponse, dispatch);
                }
            }).catch((error) => {
                handleApiError(error, dispatch);
            });
        });
    };

    useEffect(() => {
        setIsLoading(true);
        sleep(100).then(() => {
            VerifySubscription().then(async (data) => {
                if (data.status === 200) {
                    if (data["result"] === "active" || data["result"] === "trialing") {
                        await fetchSubscriptions();
                        sessionStorage.setItem('subscriptionStatus', 'active');
                        setSubscritionStatus("completed");
                        setIsLoading(false);
                        TagManager.dataLayer({
                            dataLayer: {
                              event: 'Subscription Purchased',
                              userType: userType,
                              user_id: CustomerID,
                            },
                          });
                    } else {
                        setSubscritionStatus(data["result"]);
                        setIsLoading(false);
                    }
                } else {
                    handleApiError(data, dispatch);
                }
            }
            ).finally(() => setIsLoading(false));
        });
    }, []);

    const handleExit = () => {
        return <Redirect to={{ pathname: "/OnboardScreen", state: { stage: 1 } }} />;
    }

    const Message = ({ subscriptionsDetails }) => {
        const { subscription_plan_type } = subscriptionsDetails;
        const isNotAdaptivePlan = subscription_plan_type !== 'Adaptive Advisor Firm Plan';
        const trialMessage = isNotAdaptivePlan ? ' free trial starts now' : '';

        return (
            <h2>
            {`Congratulations! Your ${subscription_plan_type}${trialMessage}. We welcome your feedback on the services we're building!`}
            </h2>
        );
    };

    return (
        <>
            <div className="toast-container">
                <Toaster />
            </div>
            {isLoading ? (
                <div className="loading-overlay">
                    <Loader/>
                </div>
            ) : (
                <div>
                    <h1 className="boardlogo"><img src="./Assets/logo.svg" /></h1>
                    <>
                        {subscriptionStatus === "completed" ?
                            (<div className="welcome">
                                <img src="./Assets/payment-success.svg"></img>
                                <Message subscriptionsDetails={subscriptionsDetails}></Message>
                                <div className="button-div">
                                    <button className="ai-btn line primary" onClick={() => Subscribed()}>
                                        Next
                                    </button>
                                </div>
                            </div>) : (
                                <div className="welcome">
                                    <img src="./Assets/payment-fail.svg"></img>
                                    <h2>
                                        Payment for the service failed. Please review your payment details.
                                    </h2>
                                    <div className="button-div">
                                        <button className="ai-btn line secondary" onClick={() => handleExit()}>
                                            Exit
                                        </button>
                                    </div>
                                </div>
                            )
                        }
                    </>
                </div>
            )}
        </>
    );
}

export default SubscriptionVerification;